var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f93",
  d: "M0 0h640v160H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 160h640v160H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#128807",
  d: "M0 320h640v160H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(3.2 0 0 3.2 320 240)"
}, /*#__PURE__*/React.createElement("circle", {
  r: 20,
  fill: "#008"
}), /*#__PURE__*/React.createElement("circle", {
  r: 17.5,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  r: 3.5,
  fill: "#008"
}), /*#__PURE__*/React.createElement("g", {
  id: "in_svg__d"
}, /*#__PURE__*/React.createElement("g", {
  id: "in_svg__c"
}, /*#__PURE__*/React.createElement("g", {
  id: "in_svg__b"
}, /*#__PURE__*/React.createElement("g", {
  id: "in_svg__a",
  fill: "#008"
}, /*#__PURE__*/React.createElement("circle", {
  r: 0.9,
  transform: "rotate(7.5 -8.8 133.5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 17.5.6 7 0 2l-.6 5L0 17.5z"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#in_svg__a",
  width: "100%",
  height: "100%",
  transform: "rotate(15)"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#in_svg__b",
  width: "100%",
  height: "100%",
  transform: "rotate(30)"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#in_svg__c",
  width: "100%",
  height: "100%",
  transform: "rotate(60)"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#in_svg__d",
  width: "100%",
  height: "100%",
  transform: "rotate(120)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#in_svg__d",
  width: "100%",
  height: "100%",
  transform: "rotate(-120)"
}))));
SvgIn.displayName = "SvgIn";
export { SvgIn as ReactComponent };
export default SvgIn;